import React from "react";
import "./PollResult.scss";
import {MDBBox} from "mdbreact";
import SubPageHeader from "../../component/SubPageHeader/SubPageHeader";
import PollGraph from "../../component/PollGraph/PollGraph";
import BottomNav from "../../component/BottomNav/BottomNav";
import PollParticipateMutation from "../../mutations/PollParticipateMutation";
import cogoToast from "cogo-toast";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllPollsQuery from "../../queries/AllPollsQuery";
import AllPollParticipationQuery from "../../queries/AllPollParticipationQuery";
import {NonEmptyArray} from "../../util";

class PollResult extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			allPolls: [],
			user_answer:[]
		}
	}

	updateLoading = (action) => {
		this.setState({
			loading: action
		})
	}

	componentDidMount() {
		this.getPollResults()
		this.getPollParticipants()
	}

	getPollResults = () => {
		let variables = {}
		this.updateLoading(true);
		fetchQuery(environment, AllPollsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.allPolls !== null) {
					let nodeData = response.allPolls.edges ? response.allPolls.edges : {};
					this.setState({
						allPolls: nodeData,

					})
				} else {
					this.setState({
						allPolls: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					allPolls: []
				})
			});
	}

	getPollParticipants = () => {
		let variables = {}
		// if (show_loading === true) {
		// 	this.updateLoading(true);
		// }
		fetchQuery(environment, AllPollParticipationQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allPollsParticipants)) {

					this.setState({
						user_answer: response.allPollsParticipants.edges.length > 0 ? response.allPollsParticipants.edges : []
					})
					// this.updateLoading(false);

				} else {
					this.setState({
						user_answer: []

					})

				}
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
			}, err => {
				console.log(err);
				// if (show_loading === true) {
				// 	this.updateLoading(false);
				// }
				this.setState({

					user_answer: []
				})
			});
	}

	submitPollResult = (answer, poll) => {
		let data = {
			pollId: poll,
			answerId: answer.node.id
		}
		let scope = this;
		this.setState({
			loading: true
		})
		PollParticipateMutation(data, function (response) {
			scope.setState({
				loading: false,
			})
			if (response.pollParticipate && response.pollParticipate.participation.id) {

				cogoToast.success(response.pollParticipate.message, {position: 'top-center'});
				scope.getPollResults();
				scope.getPollParticipants();

			} else {
				cogoToast.error(response.pollParticipate.message, {position: 'top-center'});
			}
		}, function (err) {
			scope.setState({
				loading: false
			})
			cogoToast.error(err, {position: 'top-center'});
		});

	}

	render() {
		const {allPolls} = this.state

		return (
			<MDBBox className="poll-result-component ">
				{/*<MDBContainer className=" py-2" style={{paddingLeft:"11px",paddingRight:"11px"}}>*/}
				<SubPageHeader title="Poll Results" show_action={false}/>
				{/*</MDBContainer>*/}
				{/*<hr style={{marginTop: 0}}/>*/}
				<div className={"px-4 pt-4 mb-5"}>

					<div className={"my-2"}>

						{
							allPolls.length > 0 && allPolls.map((item) => {
								return <>
									<PollGraph
										poll_data={item.node}
										submitPollResult={this.submitPollResult}
										user_answer={this.state.user_answer}
										current_poll={false}
										grants={false}
										pollResult={true}
										quiz_participated={item.node.isCompleted}
										pollChoices={item.node.pollChoices.edges}
									/>
									<br/>
								</>
							})
						}

						{/*<PollGraph poll_data={allPolls} current_poll={false} grants={true}/>*/}
						{/*<br/>*/}
						{/*<br/>*/}
						{/*<br/>*/}
						{/*<br/>*/}
					</div>

					{/*<MDBBox className="bottom-navbar">*/}
					{/*	<BottomNav/>*/}
					{/*</MDBBox>*/}
				</div>
			</MDBBox>

		)
			;
	}
}

export default PollResult;